import React, {Component} from 'react'
import DatePicker from 'material-ui/DatePicker'
import TimePicker from 'material-ui/TimePicker'
import PromotionVariantComponent from './variant'
import {connect} from 'react-redux'
import {api} from "../../../../api/index"
import {app} from "../../../../config/constants";
import TextField from 'material-ui/TextField';

import DateTimePicker from 'material-ui-datetimepicker';
import DatePickerDialog from 'material-ui/DatePicker/DatePickerDialog'
import TimePickerDialog from 'material-ui/TimePicker/TimePickerDialog';


class PromotionPeriodComponent extends Component {
	constructor(props) {
		super(props);

		this.addPeriodVariant = this.addPeriodVariant.bind(this);
		this.handleStartDateChange = this.handleStartDateChange.bind(this);
		// this.handleStartTimeChange = this.handleStartTimeChange.bind(this);
		this.handleEndDateChange = this.handleEndDateChange.bind(this);
		this.handlePeriodName = this.handlePeriodName.bind(this);
		// this.handleEndTimeChange = this.handleEndTimeChange.bind(this);

		const minDate = new Date(this.props.promotion.periods[this.props.periodKey].startDateTimeStamp);

		this.state = {
			minStartDate: minDate
		};
	}

	addPeriodVariant(event) {
		api.promotions.addPeriodVariantAction(this.props.periodKey)

		event.preventDefault();
	}

	handleStartDateChange( dateTime ) {
		const timeStamp = new Date( dateTime ).getTime();
		api.promotions.handlePeriodFieldState( 'startDateTimeStamp', timeStamp, this.props.periodKey)
	}

	handleEndDateChange( dateTime ) {
		const timeStamp = new Date( dateTime ).getTime();
		api.promotions.handlePeriodFieldState( 'endDateTimeStamp', timeStamp, this.props.periodKey)
	}

	handlePeriodName(e) {
		api.promotions.handlePeriodFieldState( 'periodName', e.target.value, this.props.periodKey)
	}

	componentWillReceiveProps(props) {
		this.setState({
			...this.state,
			minStartDate: props.period.startDateTimeStamp
		});
	}

	duplicatePeriod(event, period) {
		event.preventDefault();

		let duplicatedPeriod = JSON.parse( JSON.stringify( period ) );

		const now = Date.now();

		period.endDateTimeStamp = now;
		duplicatedPeriod.startDateTimeStamp = now;
		duplicatedPeriod.endDateTimeStamp = 0;

		duplicatedPeriod.variants.map( variant => {
			delete variant.key;
			delete variant.periodId;
		});

		delete duplicatedPeriod.key;
		delete duplicatedPeriod.promotionID;

		api.promotions.addPeriod( event, duplicatedPeriod );
	}

	deletePeriod( event, period ) {
		event.preventDefault();

		if ( window.confirm( 'Let op: Als je deze periode verwijderd, worden ook alle statistieken van deze periode en de varianten behorende bij deze periode verwijderd.') ) {
			// Go through the variants and delete the stats
			api.promotions.deleteSinglePeriod(period).then( () => {
				api.snackbar.showMessage( 'De periode is verwijderd' );
			});
		}

	}

	render() {
		return (
			<div className="grid-x grid-padding-x grid-margin-y promotion__period">
				<div className="medium-4 cell">
					<label>
						Startdatum<br/><br/>
						<DateTimePicker
							onChange={this.handleStartDateChange}
							DatePicker={DatePickerDialog}
							TimePicker={TimePickerDialog}
							format='DD MMM YYYY HH:mm'
							timeFormat="24hr"
							fullWidth={true}
							value={new Date(this.props.promotion.periods[this.props.periodKey].startDateTimeStamp)}
						/>
					</label>
				</div>
				<div className="medium-4 cell">
					<label>
						Einddatum<br/>
						<small>Laat leeg voor doorlopend</small>
						<DateTimePicker
							onChange={this.handleEndDateChange}
							DatePicker={DatePickerDialog}
							TimePicker={TimePickerDialog}
							format='DD MMM YYYY HH:mm'
							timeFormat="24hr"
							fullWidth={true}
							value={undefined !== this.props.promotion.periods[this.props.periodKey].endDateTimeStamp && 0 !== this.props.promotion.periods[this.props.periodKey].endDateTimeStamp && this.props.promotion.periods[this.props.periodKey].endDateTimeStamp !== null ? new Date(this.props.promotion.periods[this.props.periodKey].endDateTimeStamp) : ''}
							minDate={this.state.minStartDate}
						/>
					</label>
				</div>
				<div className="medium-4 cell">
					<label>
						Periodenaam. Bijv. Herfst2020.<br />
						<small>Wordt gebruikt in GA</small>
						<TextField
							onChange={this.handlePeriodName}
							value={undefined !== this.props.promotion.periods[this.props.periodKey].periodName && 0 !== this.props.promotion.periods[this.props.periodKey].periodName && this.props.promotion.periods[this.props.periodKey].periodName !== null ? this.props.promotion.periods[this.props.periodKey].periodName : ''}
							id={'actieblock-' + this.props.periodKey + '-variant-' + this.props.variantKey + '-periodName' }
							fullWidth={true}
							name="periodName"
						/>
					</label>
				</div>
				<div className="medium-4 cell">
					<button type="submit" className="button expanded success" onClick={this.addPeriodVariant}>
						<strong>Nieuwe variant</strong> <i className="fa fa-plus" aria-hidden="true"></i>
					</button>
				</div>
				<div className="medium-4 cell">
					<button type="submit" className="button expanded warning" onClick={(event) => {
						this.duplicatePeriod(event, this.props.promotion.periods[this.props.periodKey]);
					}}>
						<strong>Periode dupliceren</strong> <i className="fa fa-files-o" aria-hidden="true"></i>
					</button>
				</div>
				<div className="medium-4 cell">
					<button type="submit" className="button expanded alert" onClick={(event) => {
						this.deletePeriod(event, this.props.promotion.periods[this.props.periodKey]);
					}}>
						<strong>Periode Verwijderen</strong> <i className="fa fa-times" aria-hidden="true"></i>
					</button>
				</div>
				{
					this.props.promotion.periods[this.props.periodKey].variants.map((variant, key) => (
						<PromotionVariantComponent periodKey={this.props.periodKey} variantkey={key} key={key} />
					))
				}
			</div>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		promotion: state.promotion
	};
};

export default connect(mapStateToProps)(PromotionPeriodComponent);


// WEBPACK FOOTER //
// ./src/application/components/promotions/parts/period.js